import AssetValue from './AssetValue';

export default AssetValue;
